/* unplugin-vue-components disabled */import script from "./productFixedBottom.vue?vue&type=script&lang=ts&setup=true"
export * from "./productFixedBottom.vue?vue&type=script&lang=ts&setup=true"

import "./productFixedBottom.vue?vue&type=style&index=0&id=54291ab0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54291ab0"]])

export default __exports__